import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  message,
  Divider,
  Form,
  Space,
  Select,
  Carousel,
  InputNumber,
  Button,
  Modal,
} from "antd";
import {
  ArrowRightOutlined,
  ArrowLeftOutlined,
  SkinOutlined,
  RightOutlined,
  CheckCircleOutlined,
  UserOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { RenderImageCard } from "./components/renderImage";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const UniformesProdutoPedido = () => {
  const [form] = Form.useForm();
  const { id_produto, tipo, id_solicitante } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);
  const carousel = useRef(null);
  const [modal, contextHolder] = Modal.useModal();

  // VALORES
  const [valorTotal, setValorTotal] = useState(0.0);
  const [solicitante, setSolicitante] = useState(null);
  const [valorFinal, setValorFinal] = useState(0.0);
  const [tamanhos, setTamanhos] = useState([]);
  const [tamanhoSelected, setTamanhoSelected] = useState(null);

  useEffect(() => {
    if (
      !Number.isInteger(parseInt(id_produto)) ||
      !Number.isInteger(parseInt(tipo)) ||
      !Number.isInteger(parseInt(id_solicitante))
    ) {
      navigate("/uniformes/produtos");
    } else {
      carregarProdutoPedido(id_produto, tipo, id_solicitante);
    }
  }, [id_produto, tipo, id_solicitante]);

  useEffect(() => {}, [dados?.dados_produto?.percentual_desconto, valorTotal]);

  // CARREGAR PRODUTO
  const carregarProdutoPedido = async (produto_id, tipo_solicitante, solicitante_id) => {
    const data = {
      id_produto: produto_id,
      id_solicitante: solicitante_id,
      tipo: tipo_solicitante,
    };

    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos/carregar_produto_pedido`, data);
    if (api.statusCode === 200) {
      setDados(api.response.data);
      // TAMANHOS
      let array_tamanhos = [];
      api.response.data.tamanhos.map((t) => {
        array_tamanhos.push({ label: t.tamanho, value: t.id_tamanho });
      });
      setSolicitante(api.response.data.solicitante);
      setTamanhos(array_tamanhos);
    } else {
      navigate("/uniformes/produtos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ON CHANGE QTD
  const handleChangeQuantidade = (val) => {
    let valor = isNaN(parseFloat(dados?.dados_produto?.valor)) ? 1 : parseFloat(dados?.dados_produto?.valor);
    let percentual = isNaN(parseFloat(dados?.dados_produto?.percentual_desconto))
      ? 0
      : parseFloat(dados?.dados_produto?.percentual_desconto);
    let cota_anual = Number.isInteger(parseInt(dados?.dados_produto?.cota_anual))
      ? parseInt(dados?.dados_produto?.cota_anual)
      : 0;
    let total = val * valor;
    let valor_desconto = 0;

    setValorTotal(total);

    if (cota_anual <= 0) {
      valor_desconto = 0;
    } else if (cota_anual >= val) {
      valor_desconto = (percentual / 100) * total;
    } else if (val > cota_anual) {
      valor_desconto = (percentual / 100) * (cota_anual * valor);
    }

    setValorFinal(total - valor_desconto);
  };

  // REALIZAR PEDIDO
  const realizarPedido = async (form_data) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_pedidos/adicionar`, form_data);
    if (api.statusCode === 200) {
      message.success("Pedido realizado com sucesso!");
      navigate("/uniformes/produtos");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ON SUBMIT
  const onSubmit = (formulario) => {
    formulario.id_cad_produtos = id_produto;
    formulario.ajuste_manga = formulario.ajuste_manga ? formulario.ajuste_manga : 0;
    formulario.ajuste_altura = formulario.ajuste_altura ? formulario.ajuste_altura : 0;
    formulario.tipo = tipo;
    formulario.id_solicitante = id_solicitante;
    realizarPedido(formulario);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/uniformes/produtos")} />
            <HeaderTitle
              title="Produto Pedido"
              subtitle="Realizar novo pedido"
              icon={<ShoppingCartOutlined />}
              loading={loading}
            />
            <Divider />

            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              {dados?.dados_produto?.id && (
                <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
                  <Row>
                    <Space direction="vertical" size={0}>
                      <Text strong style={{ fontSize: 18 }}>
                        <SkinOutlined /> {dados?.dados_produto?.descricao}
                      </Text>
                    </Space>

                    <Divider style={{ margin: 5 }} />
                    <Col xs={24} sm={24} md={24} lg={12} xl={10} xxl={10} align="left" style={{ padding: 10 }}>
                      <Card
                        bodyStyle={{ padding: 0, flexGrow: 1 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "auto",
                        }}
                        actions={[
                          <ArrowLeftOutlined
                            key="left"
                            style={{ fontSize: 20 }}
                            onClick={() => carousel.current.prev()}
                          />,
                          <ArrowRightOutlined
                            key="right"
                            style={{ fontSize: 20 }}
                            onClick={() => carousel.current.next()}
                          />,
                        ]}>
                        <Carousel autoplay ref={carousel} dots={false}>
                          {dados?.imagens?.map((img) => {
                            return <RenderImagens key={img.id} idImagem={img.id} />;
                          })}
                          {dados?.imagens?.length === 0 && <RenderImagens key="empty" idImagem={0} />}
                        </Carousel>
                      </Card>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={12} xl={14} xxl={14} align="left" style={{ padding: 10 }}>
                      <Space wrap direction="vertical" style={{ width: "100%" }}>
                        <Row>
                          <Col className="gutter-row" span={24} style={{ padding: 5 }}>
                            <Text style={{ fontSize: 12 }}>
                              <UserOutlined /> {solicitante}
                            </Text>
                          </Col>

                          <Col
                            className="gutter-row"
                            xs={24}
                            sm={12}
                            md={12}
                            lg={24}
                            xl={12}
                            style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                              Valor Unitário
                            </Text>
                            <InputNumber
                              value={dados?.dados_produto?.valor}
                              min={0}
                              max={100}
                              addonBefore={<Text>R$</Text>}
                              decimalSeparator=","
                              precision={2}
                              readOnly
                              disabled={true}
                              placeholder="Informe o valor unitario!"
                              style={{ width: "100%" }}
                            />
                          </Col>

                          <Col
                            className="gutter-row"
                            xs={24}
                            sm={12}
                            md={12}
                            lg={24}
                            xl={12}
                            style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                              Valor Total
                            </Text>
                            <InputNumber
                              min={0}
                              max={100}
                              addonBefore={<Text>R$</Text>}
                              decimalSeparator=","
                              value={valorTotal}
                              precision={2}
                              readOnly
                              disabled={true}
                              placeholder="Informe o valor total!"
                              style={{ width: "100%" }}
                            />
                          </Col>

                          <Col className="gutter-row" xs={24} sm={12} md={12} lg={24} xl={12} style={{ padding: 5 }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                              Valor Desconto por un.
                            </Text>
                            <InputNumber
                              min={0}
                              max={100}
                              addonBefore={<Text>R$</Text>}
                              decimalSeparator=","
                              value={dados?.dados_produto?.cota_anual > 0 ? dados?.dados_produto?.valor_desconto : 0}
                              precision={2}
                              readOnly
                              disabled={true}
                              placeholder="Informe o valor de desconto!"
                              style={{ width: "100%" }}
                            />
                          </Col>

                          <Col className="gutter-row" xs={24} sm={12} md={12} lg={24} xl={12} style={{ padding: 5 }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                              Valor Final
                            </Text>
                            <InputNumber
                              min={0}
                              max={100}
                              addonBefore={<Text>R$</Text>}
                              decimalSeparator=","
                              value={valorFinal}
                              precision={2}
                              readOnly
                              disabled={true}
                              placeholder="Informe o valor final!"
                              style={{ width: "100%" }}
                            />
                          </Col>

                          <Col className="gutter-row" xs={24} sm={12} md={12} lg={24} xl={12} style={{ padding: 5 }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                              Quantidade
                            </Text>
                            <Form.Item
                              name="quantidade"
                              style={{ margin: 0 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Informe a quantidade!",
                                },
                              ]}>
                              <InputNumber
                                min={1}
                                max={1000}
                                onChange={(e) => handleChangeQuantidade(e)}
                                disabled={loading}
                                placeholder="Informe a quantidade!"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col className="gutter-row" xs={24} sm={12} md={12} lg={24} xl={12} style={{ padding: 5 }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                              Nº Parcelas
                            </Text>
                            <Form.Item
                              name="parcelas"
                              style={{ margin: 0 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Informe o nº de parcelas!",
                                },
                              ]}>
                              <InputNumber
                                min={1}
                                max={dados?.dados_produto?.parcelas > 0 ? dados?.dados_produto?.parcelas : 1}
                                disabled={loading}
                                placeholder="Informe o nº de parcelas!"
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Divider style={{ margin: 10 }} />

                          <Col className="gutter-row" span={24} style={{ padding: 5 }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                              Tamanho
                            </Text>
                            <Form.Item
                              name="id_uniformes_cad_tamanhos"
                              style={{ margin: 0 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Informe o tamanho!",
                                },
                              ]}>
                              <Select
                                placeholder="Selecione o tamanho"
                                disabled={loading}
                                style={{ width: "100%" }}
                                onChange={(e) => setTamanhoSelected(e)}
                                options={tamanhos}
                              />
                            </Form.Item>
                          </Col>

                          {dados?.dados_produto?.ajuste_manga === 1 && (
                            <Col className="gutter-row" xs={24} sm={12} md={12} lg={24} xl={12} style={{ padding: 5 }}>
                              <Text type="secondary" style={{ fontSize: 14 }}>
                                Ajuste de manga
                              </Text>
                              <Form.Item name="ajuste_manga" style={{ margin: 0 }}>
                                <InputNumber
                                  min={0}
                                  max={50}
                                  addonBefore={<Text>cm</Text>}
                                  decimalSeparator=","
                                  precision={2}
                                  disabled={loading}
                                  placeholder="Informe o valor!"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            </Col>
                          )}

                          {dados?.dados_produto?.ajuste_altura === 1 && (
                            <Col className="gutter-row" xs={24} sm={12} md={12} lg={24} xl={12} style={{ padding: 5 }}>
                              <Text type="secondary" style={{ fontSize: 14 }}>
                                Ajuste de altura
                              </Text>
                              <Form.Item name="ajuste_altura" style={{ margin: 0 }}>
                                <InputNumber
                                  min={0}
                                  max={50}
                                  addonBefore={<Text>cm</Text>}
                                  decimalSeparator=","
                                  precision={2}
                                  disabled={loading}
                                  placeholder="Informe o valor!"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            </Col>
                          )}

                          <Col className="gutter-row" span={24} style={{ padding: 5 }}>
                            <Button
                              icon={<CheckCircleOutlined />}
                              type="primary"
                              onClick={() => {
                                modal.confirm({
                                  title: "Deseja finalizar o pedido?",
                                  okText: "Sim",
                                  cancelText: "Cancelar",
                                  onOk() {
                                    form.submit();
                                  },
                                });
                              }}>
                              Finalizar
                            </Button>
                          </Col>
                        </Row>
                      </Space>
                    </Col>
                    <Divider style={{ margin: 10 }} />

                    <Col className="gutter-row" span={24} style={{ padding: 10 }}>
                      <Space direction="vertical">
                        <Text strong style={{ fontSize: 18 }}>
                          <RightOutlined /> Especificações
                        </Text>
                        {dados?.tamanhos?.find((e) => e.id_tamanho === tamanhoSelected) ? (
                          <Text>{dados?.tamanhos?.find((e) => e.id_tamanho === tamanhoSelected)?.especificacoes}</Text>
                        ) : (
                          <Text>Selecione um tamanho para exibir as especificações.</Text>
                        )}
                      </Space>
                    </Col>
                  </Row>
                </Form>
              )}
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};

// RENDER CARD
const RenderImagens = ({ idImagem }) => {
  return (
    <div>
      <RenderImageCard idImagem={idImagem} />
    </div>
  );
};
